import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  IconButton,
  DialogContent,
  Radio,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  TopSection,
  ProfileImageWrapper,
  ProfileImageInnerWrapper,
  TextWrapper,
  Divider,
  ToolTipStyled
} from "./styles";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import TextView from "../../../../TextView";
import SearchField from "../../ListComponents/SearchField";
import Grid from "@mui/material/Grid";
import { ASSETS } from "../../../../../utils/config";
import { colors } from "../../../../../utils";
import ReuseableButton from "../../../Button";
import { addFolder, updateFolder } from "../../../../../redux/reducers/gallery";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
// import { v4 as uuidv4 } from "uuid";
import {
  useCreateFolder,
  useUpdateFolder,
} from "../../../../../services/mutations";
import BackdropSpinner from "../../ListComponents/BackdropSpinner";
import CustomTooltip from "../../../../SegmentBuilder/Shared/CustomTooltip";
import CustomSwitch from "../../../../CustomSwitch";
import Tooltip from "@mui/material/Tooltip";

export let CreateFolderDialogProps = {};
const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  ".MuiPaper-root": {
    border: "1px solid #E1E1E1",
    borderRadius: 8,
    width: "40vw",
    // height: "68vh",
  },
}));

const StyledRadio = styled(Radio)(() => ({
  color: colors.PrimaryPurple500,
  bottom: 12,
  "&.Mui-checked": {
    color: colors.PrimaryPurple500,
  },
  "&:hover": {
    backgroundColor: "transparent !important",
  },
}));

const CreateFolderDialog = ({ onCancel = () => {} }) => {
  const [open, setOpen] = useState(false);
  const [folderTitle, setFolderTitle] = useState("");
  const [folderId, setFolderId] = useState(null);
  const createFolder = useCreateFolder();
  const _updateFolder = useUpdateFolder();
  const [parentId, setParentId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [exclude, setExclude] = useState(false);
  const [status, setStatus] = useState({
    everyone: true,
    onlyMe: false,
  });

  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
    resetState();
    onCancel && onCancel();
  };

  const formOpen = () => setOpen(true);
  const formClose = () => {
    setOpen(false);
    resetState();
  };
  const resetState = () => {
    setFolderId(null);
    setFolderTitle("");
    setExclude(false);
    setStatus({
      everyone: true,
      onlyMe: false,
    });
  };

  const handleParentId = (id) => {
    setParentId(id);
  };
  const setFolderFormData = (data = {}) => {
    const { title, visibility, id, gallery_visibility } = data || {};
    setFolderTitle(title || "");
    setExclude(gallery_visibility);
    setStatus({
      everyone: visibility === 1,
      onlyMe: visibility === 2,
    });
    setFolderId(id);
  };

  useEffect(() => {
    CreateFolderDialogProps = {
      formOpen,
      formClose,
      handleCancel,
      setFolderFormData,
      handleParentId,
      resetState,
    };
    return () => {
      CreateFolderDialogProps = {};
      setFolderId(null);
      setExclude(false);
    };
  }, []);

  const handleCheck = (type) => {
    setStatus((prev) => ({ prev, [type]: !prev[type] }));
  };

  const resetForm = () => {
    setFolderTitle("");
    setExclude(false);
    setStatus({
      everyone: true,
      onlyMe: false,
    });
  };

  const getPrimaryStatus = () => {
    if (status.everyone) return 1;
    return 2;
  };
  const handleCreate = () => {
    if (!folderTitle) return toast.error("Folder title is a required field");

    setLoader(true);
    if (!folderId) {
      let _payload = {
        name: folderTitle,
        visibility: getPrimaryStatus(),
        parent: parentId,
        tags: [{ name: "Important" }],
        gallery_visibility: exclude,
      };
      createFolder.mutate(_payload, {
        onSuccess: (data) => {
          toast.success("Folder Created Successfully");
          const payload = {
            ..._payload,
            title: folderTitle,
            parentId,
            id: data?.data?.data?.id,
            isPrimary: false,
            type: "folder",
            items: [],
            date: data?.data?.data?.updated_at,
            size: 0,
            content_amount: 0,
            gallery_visibility: exclude,
            tags: _payload?.tags?.map((tag) => tag.name),
          };
          dispatch(addFolder(payload));
          setParentId(null);
          resetForm();
          setOpen(false);
        },
        onError: (error) => {
          console.log(error);
          toast.error("Something went wrong");
        },
        onSettled: () => setLoader(false),
      });
    } else {
      let _payload = {
        id: folderId,
        name: folderTitle,
        visibility: getPrimaryStatus(),
        gallery_visibility: exclude,
      };
      _updateFolder.mutate(_payload, {
        onSuccess: () => {
          dispatch(
            updateFolder({
              id: folderId,
              updates: {
                title: folderTitle,
                visibility: getPrimaryStatus(),
                gallery_visibility: exclude,
              },
            })
          );
          resetForm();
          setOpen(false);
        },
        onError: (error) => {
          console.log({ updateError: error });
          toast.error("Something went wrong");
        },
        onSettled: () => setLoader(false),
      });
    }

    // const payload = {
    //   id: uuidv4(),
    //   title: folderTitle,
    //   visibility: getPrimaryStatus(),
    //   isPrimary: false,
    //   isFavorite: false,
    //   type: "folder",
    //   items: [],
    //   parentId: null,
    //   date: new Date().toISOString(),
    //   size: 0,
    //   content_amount: 0,
    //   tags: ["food", "nature", "people"],
    // };

    // folderId
    //   ? dispatch(
    //       updateFolder({
    //         id: folderId,
    //         updates: {
    //           title: folderTitle,
    //           visibility: getPrimaryStatus(),
    //         },
    //       })
    //     )
    //   : dispatch(addFolder(payload));
  };

  return (
    <>
      <BackdropSpinner open={loader} />
      <StyledDialog
        open={open}
        onClose={formClose}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <DialogTitle
          sx={{
            padding: "5px 10px",
          }}
        >
          <TopSection>
            <ProfileImageWrapper>
              <ProfileImageInnerWrapper>
                <div style={{ paddingTop: 7 }}>
                  <CreateNewFolderIcon
                    style={{
                      fontSize: 30,
                      color: "black",
                    }}
                  />
                </div>
                <TextWrapper>
                  <TextView variant="title">Create Folder</TextView>
                </TextWrapper>
              </ProfileImageInnerWrapper>
            </ProfileImageWrapper>
            <IconButton aria-label="close" onClick={handleCancel}>
              <CloseIcon />
            </IconButton>
          </TopSection>
        </DialogTitle>
        <Divider />

        <DialogContent>
          <TextView
            variant="subtitle"
            style={{
              color: "black",
              padding: "15px 0px",
            }}
          >
            Add Title
          </TextView>
          <SearchField
            height={48}
            placeholder="Folder Title"
            isHideIcon={true}
            value={folderTitle}
            onChange={(val) => setFolderTitle(val)}
          />

          {/* Start Exclude toggle */}
          <div style={{ display: "flex", marginTop: 10 }}>
            <CustomSwitch
              checked={exclude}
              onChange={() => setExclude(!exclude)}
              inputProps={{ "aria-label": "controlled" }}
            />
            <TextView
              variant="text"
              style={{
                marginTop: 7,
              }}
            >
              Hide Contents from Gallery
            </TextView>
            <Tooltip title="Toggling on will prevent the Folder’s contents from displaying in the ‘Wheels’ tab on the Gallery">
              <ToolTipStyled>i</ToolTipStyled>
            </Tooltip>
          </div>
          {/* End Exclude toggle */}

          <TextView
            variant="subtitle"
            style={{
              color: "black",
              padding: "15px 0px",
            }}
          >
            Visibility to:
          </TextView>
          <Grid container spacing={2}>
            <Grid item xs={0.75}>
              <img
                src={ASSETS.segmentEditor.PublicVisible}
                width={20}
                height={20}
                style={{ marginBottom: 5 }}
              />
            </Grid>
            <Grid item xs={10.25}>
              <TextView variant="text">Everyone </TextView>
            </Grid>
            <Grid item xs={1}>
              <StyledRadio
                checked={status.everyone}
                onClick={() => handleCheck("everyone")}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={0.75}>
              <img
                src={ASSETS.segmentEditor.PrivateVisible}
                width={20}
                height={20}
                style={{ marginBottom: 5 }}
              />
            </Grid>
            <Grid item xs={10.25}>
              <TextView variant="text">Only me </TextView>
            </Grid>
            <Grid item xs={1}>
              <StyledRadio
                checked={status.onlyMe}
                onClick={() => handleCheck("onlyMe")}
              />
            </Grid>
          </Grid>
          <Divider />
          <DialogActions>
            <div style={{ marginTop: 10 }}>
              <ReuseableButton
                onClick={handleCancel}
                text={"Cancel"}
                fullWidth={false}
                variant="text"
                textColor="black"
                customStyles={{
                  padding: "4px 20px",
                }}
              />

              <ReuseableButton
                text={folderId ? "Update" : "Create"}
                fullWidth={false}
                customStyles={{
                  backgroundColor: colors.PrimaryPurple,
                  padding: "4px 20px",
                }}
                onClick={handleCreate}
              />
            </div>
          </DialogActions>
        </DialogContent>
      </StyledDialog>
    </>
  );
};

export default CreateFolderDialog;
